/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiAssistantFile,
  AiAssistantFileRequestInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Assistant File
 */
export const createAssistantFile = (
    assistantId: MaybeRefOrGetter<string>,
    aiAssistantFileRequestInput: MaybeRefOrGetter<AiAssistantFileRequestInput>,
 signal?: AbortSignal
) => {
      assistantId = toValue(assistantId);
aiAssistantFileRequestInput = toValue(aiAssistantFileRequestInput);

      return axiosClient<AiAssistantFile>(
      {url: `/ai/assistants/${assistantId}/assistant_files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiAssistantFileRequestInput, signal
    },
      );
    }




export const getCreateAssistantFileMutationKey = () => ['createAssistantFile'] as const;

export const getCreateAssistantFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantFile>>, TError,CreateAssistantFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistantFile>>, TError,CreateAssistantFileMutationVariables, TContext> => {

const mutationKey = getCreateAssistantFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistantFile>>, CreateAssistantFileMutationVariables> = (props) => {
          const {assistantId,data} = props ?? {};

          return  createAssistantFile(assistantId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantFileMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistantFile>>>
    export type CreateAssistantFileMutationBody = AiAssistantFileRequestInput
    export type CreateAssistantFileMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateAssistantFileMutationVariables = {assistantId: string;data: AiAssistantFileRequestInput}

    /**
 * @summary Create AI Assistant File
 */
export const useCreateAssistantFile = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantFile>>, TError,CreateAssistantFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistantFile>>,
        TError,
        CreateAssistantFileMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAssistantFileMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete AI AssistantFile
 */
export const deleteAiAssistantFile = (
    assistantId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      assistantId = toValue(assistantId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/assistants/${assistantId}/assistant_files/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiAssistantFileMutationKey = () => ['deleteAiAssistantFile'] as const;

export const getDeleteAiAssistantFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistantFile>>, TError,DeleteAiAssistantFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistantFile>>, TError,DeleteAiAssistantFileMutationVariables, TContext> => {

const mutationKey = getDeleteAiAssistantFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiAssistantFile>>, DeleteAiAssistantFileMutationVariables> = (props) => {
          const {assistantId,id} = props ?? {};

          return  deleteAiAssistantFile(assistantId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiAssistantFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiAssistantFile>>>

    export type DeleteAiAssistantFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiAssistantFileMutationVariables = {assistantId: string;id: string}

    /**
 * @summary Delete AI AssistantFile
 */
export const useDeleteAiAssistantFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistantFile>>, TError,DeleteAiAssistantFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiAssistantFile>>,
        TError,
        DeleteAiAssistantFileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiAssistantFileMutationOptions(options), queryClient);
    }
